module.exports = "/images/success_contact.png?6dba121093e9e2043ee9f69e9524c4ac";